__turbopack_context__.v({
  "buttonSend": "ButtonSend-module-scss-module__NNLFRq__buttonSend",
  "buttonSendIcon": "ButtonSend-module-scss-module__NNLFRq__buttonSendIcon",
  "checkbox": "ButtonSend-module-scss-module__NNLFRq__checkbox",
  "checkbox__input": "ButtonSend-module-scss-module__NNLFRq__checkbox__input",
  "formCallBtnText": "ButtonSend-module-scss-module__NNLFRq__formCallBtnText",
  "formWrapper": "ButtonSend-module-scss-module__NNLFRq__formWrapper",
});
